import { NgModule } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';
import { provideZxvbnServiceForPSM } from 'angular-password-strength-meter/zxcvbn';
import { PipesModule } from '../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PasswordStrengthMeterComponent } from 'angular-password-strength-meter';

@NgModule({
  declarations: [
    ChangePasswordComponent
  ],
  exports: [
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    PopupModule,
    TranslateModule,
    PipesModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    ReactiveFormsModule,
    InputsModule,
    PasswordStrengthMeterComponent
  ],
  providers: [
    provideZxvbnServiceForPSM()
  ]
})
export class ChangePasswordModule { }
